
import React from "react";
import { useAuthForm } from "./auth/useAuthForm";
import FormFields from "./auth/FormFields";
import FormFooter from "./auth/FormFooter";
import { AuthFormProps } from "./auth/types";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { emailConfirmationMessage } from "@/lib/auth-errors";

const AuthForm = ({ onSuccess }: AuthFormProps) => {
  const {
    isLogin,
    email,
    setEmail,
    emailError,
    password,
    setPassword,
    fullName,
    setFullName,
    showPassword,
    setShowPassword,
    loading,
    showConfirmMessage,
    passwordErrors,
    trackUserInteraction,
    trackKeyPress,
    toggleFormMode,
    handleSubmit
  } = useAuthForm(onSuccess);

  return (
    <div className="p-4 border border-gray-200 rounded-lg">
      <h3 className="text-lg font-semibold mb-4">
        {isLogin ? "Logi sisse" : "Loo konto"}
      </h3>
      
      {showConfirmMessage && (
        <Alert className="mb-4 bg-blue-50 border-blue-200">
          <AlertDescription>{emailConfirmationMessage}</AlertDescription>
        </Alert>
      )}
      
      <form 
        onSubmit={handleSubmit} 
        className="space-y-4"
        onMouseMove={trackUserInteraction}
        onKeyDown={trackKeyPress}
      >
        <FormFields 
          isLogin={isLogin}
          email={email}
          setEmail={setEmail}
          emailError={emailError}
          password={password}
          setPassword={setPassword}
          fullName={fullName}
          setFullName={setFullName}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          passwordErrors={passwordErrors}
        />
        
        <FormFooter 
          isLogin={isLogin}
          loading={loading}
          toggleFormMode={toggleFormMode}
        />
      </form>
    </div>
  );
};

export default AuthForm;
